import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/**
 * StatusBadge
 * Small rounded pill used across all Reports for boolean / status style values
 * e.g. Yes / No, ON / OFF, Active / Inactive.
 *
 * Usage:
 *   <StatusBadge value={row.isActive} />                         -> Yes / No
 *   <StatusBadge value={row.ignitionStatus} trueLabel="ON" falseLabel="OFF" />
 */
function StatusBadge({ value, trueLabel, falseLabel, trueValues }) {
  const normalized = typeof value === "string" ? value.trim().toLowerCase() : value;

  const isTrue =
    typeof value === "boolean"
      ? value
      : trueValues.map((v) => v.toLowerCase()).includes(String(normalized));

  const label = isTrue ? trueLabel : falseLabel;

  const positive = {
    bg: "#E9F9EE",
    text: "#1CA653",
    dot: "#1CA653",
  };
  const negative = {
    bg: "#FDECEC",
    text: "#E53E3E",
    dot: "#E53E3E",
  };

  const palette = isTrue ? positive : negative;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        px: "10px",
        py: "3px",
        borderRadius: "999px",
        backgroundColor: palette.bg,
        lineHeight: 1.2,
      }}
    >
      <MDBox
        component="span"
        sx={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: palette.dot,
          display: "inline-block",
        }}
      />
      <MDTypography
        variant="caption"
        fontWeight="bold"
        sx={{ color: palette.text, fontSize: "0.75rem" }}
      >
        {label}
      </MDTypography>
    </MDBox>
  );
}

StatusBadge.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
  trueLabel: PropTypes.string,
  falseLabel: PropTypes.string,
  trueValues: PropTypes.arrayOf(PropTypes.string),
};

StatusBadge.defaultProps = {
  value: false,
  trueLabel: "Yes",
  falseLabel: "No",
  trueValues: ["true", "yes", "on", "1", "active"],
};

export default StatusBadge;